<template>
  <div ref="globalTimerRef" :class="['global-timer-container center', { shake: isBellRing }]">
    <a-progress
      class="global-timer-progress"
      type="circle"
      stroke-color="#1976ff"
      :stroke-width="3"
      :percent="percent"
      @click.right.prevent="popoverVisible = !popoverVisible"
      @click="handleCountDown"
    >
      <template #format>
        <div class="inner-text">
          <img v-show="isBellRing" src="@/assets/common/global-timer-ring.png" alt="" />
          <div v-show="!isBellRing" class="time-text">{{ timeText }}</div>
          <div>{{ isBellRing ? '点击开始结束' : isStart ? '点击结束计时' : '点击开始计时' }}</div>
        </div>
      </template>
    </a-progress>

    <div v-show="popoverVisible" class="popover">
      <div class="popover-item" @click="hide">关闭</div>
      <div v-for="item in optionList" :key="item.value" class="popover-item mt-14" @click="handleClickOption(item)">
        {{ item.label }}
      </div>
      <div class="popover-item mt-14" @click="handleClickCustom">自定义</div>
    </div>

    <CustomTimerModal ref="customTimerModalRef" @confirm="onConfirmTimer" />
  </div>
</template>

<script>
import { formatDuration } from '@/utils'
import Hammer from 'hammerjs'
import CustomTimerModal from '@/components/globalTimer/CustomTimerModal.vue'

export default {
  name: 'GlobalTimer',
  components: { CustomTimerModal },
  data() {
    return {
      popoverVisible: false,
      totalTime: 0,
      time: 0, // 单位：秒
      isStart: false,
      isBellRing: false,
      timer: null,
      optionList: [
        { label: '1分钟', value: 1 },
        { label: '3分钟', value: 3 },
        { label: '5分钟', value: 5 },
        { label: '10分钟', value: 10 }
      ]
    }
  },
  computed: {
    timeText() {
      return formatDuration(this.time)
    },
    percent() {
      let percent = Math.round((this.time / this.totalTime) * 100)
      if (percent < 0) {
        percent = 0
      }
      return percent
    }
  },
  mounted() {
    this.initDoubleTapEvent()
    document.addEventListener('click', this.clickOutSide)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutSide)
  },
  methods: {
    hide() {
      this.popoverVisible = false
      this.$bus.$emit('hideGlobalTimer')
    },
    clickOutSide(e) {
      const el = this.$refs.globalTimerRef
      if (el.contains(e.target)) return
      this.popoverVisible = false
    },
    initDoubleTapEvent() {
      const mc = new Hammer.Manager(this.$refs.globalTimerRef)
      const doubleTap = new Hammer.Tap({ event: 'doubletap', taps: 2 })
      mc.add(doubleTap)
      mc.on('doubletap', () => {
        this.popoverVisible = !this.popoverVisible
      })
    },
    handleCountDown() {
      if (this.totalTime === 0) return
      if (this.isBellRing) {
        this.time = this.totalTime
        this.isBellRing = false
        return
      }
      if (this.isStart) {
        clearInterval(this.timer)
        this.isStart = false
      } else {
        this.isStart = true
        this.timer = setInterval(() => {
          this.time--
          if (this.time <= 0) {
            clearInterval(this.timer)
            this.isStart = false
            this.isBellRing = true
          }
        }, 1000)
      }
    },
    handleClickOption(item) {
      console.log(item)
      this.time = item.value * 60
      this.totalTime = this.time
      this.popoverVisible = false
    },
    handleClickCustom() {
      this.popoverVisible = false
      this.$refs.customTimerModalRef.show()
    },
    onConfirmTimer(minutes) {
      this.time = minutes * 60
      this.totalTime = this.time
    }
  }
}
</script>

<style scoped lang="scss">
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.global-timer-container {
  position: fixed;
  top: 68px;
  right: 28px;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  background-color: #fff;
  &.shake {
    animation: shake 800ms ease-in-out infinite;
  }
}

::v-deep .global-timer-progress {
  cursor: pointer;
  .ant-progress-inner {
    width: 92px !important;
    height: 92px !important;
  }
}

.inner-text {
  font-weight: 400;
  font-size: 10px;
  color: #999999;
}

.time-text {
  font-size: 28px;
  color: #333333;
}

.popover {
  position: absolute;
  left: 50%;
  top: 80px;
  transform: translateX(-50%);
  width: 92px;
  box-sizing: border-box;
  padding: 14px 0;
  background: linear-gradient(180deg, #e8f1ff 0%, #f1f1f1 100%);
  border-radius: 16px;
  border: 1px solid #d1e4ff;
  &::before {
    content: '';
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 10px solid transparent;
    border-bottom: 10px solid #d1e4ff;
  }

  .popover-item {
    width: 100%;
    text-align: center;
    font-weight: 400;
    font-size: 17px;
    color: #333333;
    &:hover {
      color: #1976ff;
    }
  }
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
  50% {
    transform: translate3d(-4px, 0, 0);
  }
}
</style>
